import React, { useState } from "react";
import "./Navbar.css";
import { FaBars } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        
        <div className="nav-img">
          <img src="./svpl-logo-bg.webp" className="nav-logo" alt="logo" loading='lazy'/>
        </div>

        <div className={`nav-links ${isOpen ? "open" : ""}`}>
          {isOpen && (
            <div className="close-icon" onClick={() => setIsOpen(false)}>
              <RxCross2 />
            </div>
          )}

          <NavLink 
            to="/" 
            className={({ isActive }) => (isActive ? "active-link" : "")}
            onClick={() => setIsOpen(false)}
          >
            Home
          </NavLink>

          <NavLink 
            to="/about-us" 
            className={({ isActive }) => (isActive ? "active-link" : "")}
            onClick={() => setIsOpen(false)}
          >
            About Us
          </NavLink>

          <NavLink 
            to="/project" 
            className={({ isActive }) => (isActive ? "active-link" : "")}
            onClick={() => setIsOpen(false)}
          >
            Projects
          </NavLink>

            <NavLink 
            to="/gallery" 
            className={({ isActive }) => (isActive ? "active-link" : "")}
            onClick={() => setIsOpen(false)}
          >
            Gallery
          </NavLink>

          <NavLink 
            to="/contact-us" 
            className={({ isActive }) => (isActive ? "active-link" : "")}
            onClick={() => setIsOpen(false)}
          >
            Contact Us
          </NavLink>
        </div>

        {!isOpen && (
          <div className="menu-icon" onClick={() => setIsOpen(true)}>
            <FaBars />
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
